import RestService from '../services/rest';

function deleteCard(card) {
  return RestService.postAuthenticated(`users/card/delete?userId=${card.userId}&cardId=${card.id}&token=${card.token}`);
}

export default {
  deleteCard,
};
